import moment from "moment";

export default {
    methods: {
        conditionPrint(item, subject = 'disc') {
            const obj = item.condition.find(c => c.subject === subject);

            return obj && obj.grade ? obj.grade : '';
        },
        conditionsPrint(item) {
            return item.condition.map(c => {
                return {
                    grade: c.grade,
                    subject: c.subject ? c.subject.charAt(0).toUpperCase() + c.subject.slice(1) : '',
                    notes: c.notes.join(', '),
                }
            });
        },
        artistPrint(item) {
            if (item.release.artist && item.release.artist.first) {
                return [ item.release.artist.first, item.release.artist.last ].join(' ');
            }

            return item.release.artist ? item.release.artist.last : '';
        },
        titlePrint(item) {
            return item.release.titles ? item.release.titles.join(' / ') : '';
        },
        editionPrint(item) {
            return item.release.pressing.filter(pressing => {
                if (pressing.type === 'edition') {
                    return pressing.text;
                }
            });
        },
        pressingPrint(item) {
            return item.release.pressing.map(p => {
                return p.text;
            });
        },
        pressingFullPrint(item) {
            let pressings = {};

            item.release.pressing.forEach(p => {
                let type = p.type ? p.type.charAt(0).toUpperCase() + p.type.slice(1) : '';

                if (!pressings[type]) {
                    pressings[type] = [];
                }

                pressings[type].push(p.text);
            });

            for (let type in pressings) {
                if (pressings[type]) {
                    pressings[type] = pressings[type].join(', ');
                }
            }

            return pressings;
        },

        notesPrint(item) {
            let notes = [];

            item.notes.forEach(note => {
                if (!note.type) {
                    notes.push(note.text);
                }
            });

            
            return notes;
        },

        formatPrint(media = []) {
            const formats = media.map(item => {
                let countStr = item.count > 1 ? `${item.count} x ` : ``;
                const speed = item.speed ? `(${item.speed} RPM)` : '';
                const attributes = this.buildMediaAttributesPrint(item);
                if (item.duration === 'CD' || item.duration === 'CD Single' || item.duration === 'Cassette' || item.duration === 'Cassette Single') {
                    return `${countStr} ${item.duration} ${attributes}`
                }
                return `${countStr}${item.size}" ${item.duration} ${speed} ${attributes}`;

            });

            return formats.filter((f)=> f !== null).join(', ');
        },
        buildMediaAttributesPrint(media) {
            if (media.attributes) {
                return media.attributes.join(', ');
            }

            return [];
        },
        locationPrint(item) {
            return item.listing.location || '';
        },
        pricePrint(item) {
            return item.listing.price || 0;
        },
        noActiveHasInactivePrint(inventoryItem, location) {
            let noActive = false;
            let hasInactive = false;

            inventoryItem.listing.forEach(listing => {
                if (listing.type === 'active' && listing.location === location && listing.count === 0) {
                    noActive = true;
                }

                if (listing.type === 'inactive' && listing.location === location && listing.count > 0) {
                    hasInactive = true;
                }
            });

            return noActive === true && hasInactive === true;
        },
        hasMoreActivePrint(inventoryItem, location) {
            let hasMoreActive = false;

            inventoryItem.listing.forEach(listing => {
                if (listing.type === 'active' && listing.location === location && listing.count > 0) {
                    hasMoreActive = true;
                }
            });

            return hasMoreActive;
        },
        isItemRecentPrint(item, numDays = 3) {
            let listDate = moment(item.listing.date);
            let compareDate = moment().subtract(numDays, 'days');

            return listDate.isAfter(compareDate);
        }
    },
}